export const sklepy = [
  {
    id: 1,
    miejscowosc: 'Żnin',
    lokalizacja: [
      { ulica: 'Śniadeckich 17', telefon: '530 210 866' },
      { ulica: 'Śniadeckich 23', telefon: '574 791 043' },
      { ulica: 'Kościuszki 19/1', telefon: '533 301 374' },
      { ulica: 'Graniczna 23', telefon: '790 204 742' },
    ],
  },
  {
    id: 2,
    miejscowosc: 'Łabiszyn',
    lokalizacja: [
      { ulica: 'Powstańców Wielkopolskich 26', telefon: '533 301 273' },
      { ulica: 'Tysiąclecia 21', telefon: '533 301 285' },
      { ulica: 'Szubińska 15 Sklep ABC', telefon: '533 301 383' },
    ],
  },
  {
    id: 3,
    miejscowosc: 'Barcin',
    lokalizacja: [{ ulica: '4-Tego Stycznia 2', telefon: '533 301 376' }],
  },
  {
    id: 4,
    miejscowosc: 'Szubin',
    lokalizacja: [
      { ulica: 'Generała Bema 3', telefon: '690 881 676' },
      { ulica: '3-Go Maja 18', telefon: '790 219 910' },
    ],
  },
  {
    id: 5,
    miejscowosc: 'Bydgoszcz',
    lokalizacja: [
      { ulica: 'Wojska Polskiego 23', telefon: '533 301 709' },
      { ulica: 'Konopnicka 28', telefon: '533 301 378' },
      { ulica: 'Sienkieiwcza 40 ', telefon: '730 014 107' },
      { ulica: 'Ogrody 20', telefon: '574 821 026' },
      { ulica: 'Pielęgniarska 17', telefon: '574 791 042' },
      { ulica: 'Chocimska 11', telefon: '790 219 921' },
      { ulica: 'Gołębia 38', telefon: '536 260 125' },
    ],
  },
  {
    id: 6,
    miejscowosc: 'Osielsko',
    lokalizacja: [{ ulica: 'Centralna 2 D', telefon: '530 224 309' }],
  },
];
